import { inject, Injectable } from '@angular/core';
import { TopicApi } from '../data/topic/topic.api';
import { EntryApi } from '../data/entry/entry.api';
import { SupaStatisticsApi } from '../data/supa-statistics/supa-statistics.api';

@Injectable({providedIn: 'root'})
export class InitializeService {
  private topicApi = inject(TopicApi);
  private entryApi = inject(EntryApi);
  private statisticsApi = inject(SupaStatisticsApi);

  initialize() {
    return Promise.all([
      this.topicApi.fetch(),
      this.statisticsApi.fetchStreaks(),
      this.statisticsApi.fetchMonthlyStreaks()
    ])
  }
}
